// This file is autogenerated. DO NOT MODIFY

export const FONT_FAMILY = {
  INTER: 'Inter',
  NEUE_HAAS_GROTESK_DISPLAY_PRO: 'Neue Haas Grotesk Display Pro',
  SF_PRO_TEXT: 'SF Pro Text'
} as const;

export const FONT_WEIGHT = {
  REGULAR: 'Regular',
  MEDIUM: 'Medium',
  SEMI_BOLD: 'Semi Bold',
  EXTRA_BOLD: 'Extra Bold',
  EXTRA_LIGHT: 'Extra Light',
  _65_MEDIUM: '65 Medium',
  _55_ROMAN: '55 Roman'
} as const;

export const LINE_HEIGHT_UNIT = { PERCENT: 'PERCENT', PIXELS: 'PIXELS' } as const;

export const LETTER_SPACING_UNIT = { PERCENT: 'PERCENT', PIXELS: 'PIXELS' } as const;

export const TEXT_CASE = { ORIGINAL: 'ORIGINAL', UPPER: 'UPPER' } as const;

export const TEXT_DECORATION = { NONE: 'NONE', UNDERLINE: 'UNDERLINE' } as const;

export const TYPOGRAPHY = {
  DISPLAY: {
    X_LARGE: {
      REGULAR: {
        fontSize: 60,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 60,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 60,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 60,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 60,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 60,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 60,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    LARGE: {
      REGULAR: {
        fontSize: 52,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 52,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 52,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 52,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 52,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 52,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 52,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    SMALL: {
      REGULAR: {
        fontSize: 44,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 44,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'MEDIUM_*LH48': {
        fontSize: 44,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 48,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 44,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 44,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 44,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 44,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 44,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    }
  },
  HEADINGS: {
    HEADING_1: {
      REGULAR: {
        fontSize: 40,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 40,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 40,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 40,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 40,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 40,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 40,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    HEADING_2: {
      REGULAR: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    HEADING_3: {
      REGULAR: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD_UL: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      EXTRA_BOLD: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    HEADING_4: {
      REGULAR: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'SEMI_BOLD_*LH40': {
        fontSize: 28,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 40,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    HEADING_5: {
      REGULAR: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'MEDIUM_*LH32': {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 32,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'SEMI_BOLD_*LH24': {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 32,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'SEMI_BOLD_*LH24_UL': {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 32,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      SEMI_BOLD_UL: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      EXTRA_BOLD: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    HEADING_6: {
      REGULAR: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'SEMI_BOLD_*LH24': {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 24,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD_UL: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      BRANDED_65M: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    }
  },
  PARAGRAPH: {
    LARGE: {
      REGULAR: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      REGULAR_UL: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      MEDIUM: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'MEDIUM_*LH28': {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 28,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM_UL: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      SEMI_BOLD: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    DEFAULT: {
      REGULAR: {
        fontSize: 16,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      REGULAR_UL: {
        fontSize: 16,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      MEDIUM: {
        fontSize: 16,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'MEDIUM_*LH24': {
        fontSize: 16,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 24,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM_UL: {
        fontSize: 16,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      'MEDIUM_UL_*LH24': {
        fontSize: 16,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 24,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      SEMI_BOLD: {
        fontSize: 16,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 16,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    SMALL: {
      REGULAR: {
        fontSize: 14,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'REGULAR_*LH20': {
        fontSize: 14,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 20,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      REGULAR_UL: {
        fontSize: 14,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      MEDIUM: {
        fontSize: 14,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'MEDIUM_*LH20': {
        fontSize: 14,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 20,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM_UL: {
        fontSize: 14,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      'MEDIUM_UL_*LH20': {
        fontSize: 14,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 20,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      SEMI_BOLD: {
        fontSize: 14,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD_UL: {
        fontSize: 14,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      EXTRA_BOLD: {
        fontSize: 14,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    MICRO: {
      REGULAR: {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      REGULAR_UL: {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      'REGULAR_*LH20': {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 20,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'REGULAR_UL_*LH20': {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 20,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      'REGULAR__*LH9': {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 9,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'MEDIUM_*LH20': {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 20,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM_UL: {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      'MEDIUM_UL_*LH20': {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 20,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      SEMI_BOLD: {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 12,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    NANO: {
      REGULAR: {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'REGULAR_*LH9': {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 9,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'MEDIUM_*LH12': {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 12,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'MEDIUM_*LH16': {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 16,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'MEDIUM_UL_*LH16': {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 16,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      'MEDIUM__*LH18': {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 18,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM_UL: {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      'MEDIUM_UL_*LH18': {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 18,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      SEMI_BOLD: {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'SEMI_BOLD_*LH18': {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 18,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 10,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    PICO: {
      REGULAR: {
        fontSize: 9,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'REGULAR__*LH10': {
        fontSize: 9,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 10,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 9,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM_UL: {
        fontSize: 9,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      SEMI_BOLD: {
        fontSize: 9,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 9,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    FEMTO: {
      REGULAR: {
        fontSize: 8,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 8,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 8,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      'SEMI_BOLD_*LH12': {
        fontSize: 8,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 12,
        lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 8,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: 0,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    }
  },
  OVERLINE: {
    SMALL: {
      fontSize: 14,
      fontFamily: FONT_FAMILY.INTER,
      fontWeight: FONT_WEIGHT.SEMI_BOLD,
      lineHeight: 150,
      lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
      letterSpacing: 0,
      letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
      textCase: TEXT_CASE.UPPER,
      textDecoration: TEXT_DECORATION.NONE
    },
    MICRO: {
      fontSize: 12,
      fontFamily: FONT_FAMILY.INTER,
      fontWeight: FONT_WEIGHT.SEMI_BOLD,
      lineHeight: 150,
      lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
      letterSpacing: 0,
      letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
      textCase: TEXT_CASE.UPPER,
      textDecoration: TEXT_DECORATION.NONE
    },
    'MICRO_*LH12': {
      fontSize: 12,
      fontFamily: FONT_FAMILY.INTER,
      fontWeight: FONT_WEIGHT.SEMI_BOLD,
      lineHeight: 12,
      lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
      letterSpacing: 0,
      letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
      textCase: TEXT_CASE.UPPER,
      textDecoration: TEXT_DECORATION.NONE
    },
    MICRO_UL: {
      fontSize: 12,
      fontFamily: FONT_FAMILY.INTER,
      fontWeight: FONT_WEIGHT.SEMI_BOLD,
      lineHeight: 150,
      lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
      letterSpacing: 0,
      letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
      textCase: TEXT_CASE.UPPER,
      textDecoration: TEXT_DECORATION.UNDERLINE
    },
    'NANO_*LH10': {
      fontSize: 10,
      fontFamily: FONT_FAMILY.INTER,
      fontWeight: FONT_WEIGHT.SEMI_BOLD,
      lineHeight: 10,
      lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
      letterSpacing: 0,
      letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
      textCase: TEXT_CASE.UPPER,
      textDecoration: TEXT_DECORATION.NONE
    }
  },
  MOBILE: {
    MOB_DISPLAY: {
      X_LARGE: {
        REGULAR: {
          fontSize: 52,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.REGULAR,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        MEDIUM: {
          fontSize: 52,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        SEMI_BOLD: {
          fontSize: 52,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.SEMI_BOLD,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        EXTRA_BOLD: {
          fontSize: 52,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.EXTRA_BOLD,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        EXTRA_LIGHT: {
          fontSize: 52,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        BRANDED_65M: {
          fontSize: 52,
          fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
          fontWeight: FONT_WEIGHT._65_MEDIUM,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        BRANDED_55R: {
          fontSize: 52,
          fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
          fontWeight: FONT_WEIGHT._55_ROMAN,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        }
      },
      LARGE: {
        REGULAR: {
          fontSize: 44,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.REGULAR,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        MEDIUM: {
          fontSize: 44,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        SEMI_BOLD: {
          fontSize: 44,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.SEMI_BOLD,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        EXTRA_BOLD: {
          fontSize: 44,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.EXTRA_BOLD,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        EXTRA_LIGHT: {
          fontSize: 44,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        BRANDED_65M: {
          fontSize: 44,
          fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
          fontWeight: FONT_WEIGHT._65_MEDIUM,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        BRANDED_55R: {
          fontSize: 44,
          fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
          fontWeight: FONT_WEIGHT._55_ROMAN,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        }
      },
      SMALL: {
        REGULAR: {
          fontSize: 40,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.REGULAR,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        MEDIUM: {
          fontSize: 40,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        'MEDIUM_*LH48': {
          fontSize: 40,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 48,
          lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        SEMI_BOLD: {
          fontSize: 40,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.SEMI_BOLD,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        EXTRA_BOLD: {
          fontSize: 40,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.EXTRA_BOLD,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        EXTRA_LIGHT: {
          fontSize: 40,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        BRANDED_65M: {
          fontSize: 40,
          fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
          fontWeight: FONT_WEIGHT._65_MEDIUM,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        BRANDED_55R: {
          fontSize: 40,
          fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
          fontWeight: FONT_WEIGHT._55_ROMAN,
          lineHeight: 120,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: -2,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        }
      }
    },
    MOB_HEADING_1: {
      REGULAR: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 36,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    MOB_HEADING_2: {
      REGULAR: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 26,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 32,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    MOB_HEADING_3: {
      REGULAR: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD_UL: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      EXTRA_BOLD: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 28,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    MOB_HEADING_4: {
      REGULAR: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 24,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    MOB_HEADING_5: {
      REGULAR: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD_UL: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.UNDERLINE
      },
      EXTRA_BOLD: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 20,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    MOB_HEADING_6: {
      REGULAR: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.REGULAR,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      MEDIUM: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      SEMI_BOLD: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.SEMI_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_BOLD: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_BOLD,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      EXTRA_LIGHT: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.INTER,
        fontWeight: FONT_WEIGHT.EXTRA_LIGHT,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_65M: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._65_MEDIUM,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      },
      BRANDED_55R: {
        fontSize: 18,
        fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
        fontWeight: FONT_WEIGHT._55_ROMAN,
        lineHeight: 120,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -2,
        letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    },
    MOB_PARAGRAPH: {
      MOB_LARGE: {
        REGULAR: {
          fontSize: 16,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.REGULAR,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        REGULAR_UL: {
          fontSize: 16,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.REGULAR,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.UNDERLINE
        },
        MEDIUM: {
          fontSize: 16,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        'MEDIUM_*LH28': {
          fontSize: 16,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 28,
          lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        MEDIUM_UL: {
          fontSize: 16,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.UNDERLINE
        },
        SEMI_BOLD: {
          fontSize: 16,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.SEMI_BOLD,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        EXTRA_BOLD: {
          fontSize: 16,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.EXTRA_BOLD,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        }
      },
      MOB_DEFAULT: {
        REGULAR: {
          fontSize: 14,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.REGULAR,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        REGULAR_UL: {
          fontSize: 14,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.REGULAR,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.UNDERLINE
        },
        MEDIUM: {
          fontSize: 14,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        'MEDIUM_*LH24': {
          fontSize: 14,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 24,
          lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        MEDIUM_UL: {
          fontSize: 14,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.UNDERLINE
        },
        'MEDIUM_UL_*LH24': {
          fontSize: 14,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 24,
          lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.UNDERLINE
        },
        SEMI_BOLD: {
          fontSize: 14,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.SEMI_BOLD,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        EXTRA_BOLD: {
          fontSize: 14,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.EXTRA_BOLD,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        }
      },
      MOB_SMALL: {
        REGULAR: {
          fontSize: 12,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.REGULAR,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        'REGULAR_*LH20': {
          fontSize: 12,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.REGULAR,
          lineHeight: 20,
          lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        REGULAR_UL: {
          fontSize: 12,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.REGULAR,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.UNDERLINE
        },
        MEDIUM: {
          fontSize: 12,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        'MEDIUM_*LH20': {
          fontSize: 12,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 20,
          lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        MEDIUM_UL: {
          fontSize: 12,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.UNDERLINE
        },
        'MEDIUM_UL_*LH20': {
          fontSize: 12,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.MEDIUM,
          lineHeight: 20,
          lineHeightUnit: LINE_HEIGHT_UNIT.PIXELS,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.UNDERLINE
        },
        SEMI_BOLD: {
          fontSize: 12,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.SEMI_BOLD,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        },
        SEMI_BOLD_UL: {
          fontSize: 12,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.SEMI_BOLD,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.UNDERLINE
        },
        EXTRA_BOLD: {
          fontSize: 12,
          fontFamily: FONT_FAMILY.INTER,
          fontWeight: FONT_WEIGHT.EXTRA_BOLD,
          lineHeight: 150,
          lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
          letterSpacing: 0,
          letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
          textCase: TEXT_CASE.ORIGINAL,
          textDecoration: TEXT_DECORATION.NONE
        }
      }
    }
  },
  NATIVE: {
    IOS: {
      STATUS_BAR_ICON_TEXT: {
        fontSize: 10,
        fontFamily: FONT_FAMILY.SF_PRO_TEXT,
        fontWeight: FONT_WEIGHT.MEDIUM,
        lineHeight: 150,
        lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
        letterSpacing: -0.23,
        letterSpacingUnit: LETTER_SPACING_UNIT.PIXELS,
        textCase: TEXT_CASE.ORIGINAL,
        textDecoration: TEXT_DECORATION.NONE
      }
    }
  },
  PRESENTATIONS: {
    BIG_TITLE: {
      fontSize: 80,
      fontFamily: FONT_FAMILY.NEUE_HAAS_GROTESK_DISPLAY_PRO,
      fontWeight: FONT_WEIGHT._65_MEDIUM,
      lineHeight: 150,
      lineHeightUnit: LINE_HEIGHT_UNIT.PERCENT,
      letterSpacing: -2,
      letterSpacingUnit: LETTER_SPACING_UNIT.PERCENT,
      textCase: TEXT_CASE.ORIGINAL,
      textDecoration: TEXT_DECORATION.NONE
    }
  }
} as const;

export type EuroaTypographies = typeof TYPOGRAPHY;
export type EuroaTypography = EuroaTypographies[keyof EuroaTypographies];
